import { useAccount, useIsOwner } from '~publish/contexts/AccountContext'

type BufferHomeAvailability = {
  hasAccess: boolean
  loading: boolean
}

/**
 * Resolves whether Buffer Home should be available to the current user.
 *
 * Buffer Home is restricted to the organization owner — its streak and
 * posting-goal data is owner-gated on the backend, so non-owners would see
 * empty, inconsistent metrics.
 *
 * Ownership is derived from account data, so `loading` stays true until the
 * account has resolved — otherwise `isOwner` is briefly false and we'd hide
 * Home from an actual owner during the initial load.
 */
export const useHasAccessToBufferHome = (): BufferHomeAvailability => {
  const { loading } = useAccount()
  const isOwner = useIsOwner()

  return {
    hasAccess: isOwner,
    loading,
  }
}
